import moment from 'moment';

import dayjs from 'dayjs';

import { ref, onMounted, onBeforeUnmount } from 'vue';


const TZ = '+00:00'; // UTC
// const TZ = '+03:00'; // MSK

const DAY = 60 * 60 * 24 * 1000;
const DATE_FORMAT = 'YYYY-MM-DD';
const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';

const getMoment = dateStr => moment(dateStr).utcOffset(TZ);
// especially for conversion native date to moment when DAY is used, not time
const getMomentUtc = dateStr => moment(dateStr).utcOffset(0, true);

// возможно, неверно работает, и надо getMomentUtc. Но нигде не используется.
// eslint-disable-next-line no-unused-vars
const dateToString = dateValue => getMoment(dateValue).startOf('day').format(DATE_FORMAT);
const dateToUnix = dateValue => dayjs.isDayjs(dateValue) ? dateValue.toDate().getTime() : dateValue.getTime();
const isDayjs = value => dayjs.isDayjs(value);

// # TODO dateUtils: когда надо simple, когда надо utc?
// # TODO dateUtils: проверить везде dayjs для даты в utc
const dayJsToStringFormat = (dayObj, format) => dayObj.utc().format(format);
const dayJsToString = dayObj => dayJsToStringFormat(dayObj, DATE_FORMAT);
const dayJsDatetimeToString = dayObj => dayJsToStringFormat(dayObj, DATETIME_FORMAT);
// always convert date like 2025-11-16 to dayjs with that function
const dateStrToDayJs = dateStr => dayjs.utc(dateStr);
// for example utcDatetimeStrToDayJs(point.x, 'YYYY-MM-DD HH:mm')
const utcDatetimeStrToDayJs = (datetimeStr, format) => dayjs.utc(datetimeStr, format);

const datetimeToStringFormat = (date, format) => {
	if (date == null) {
		return '—';
	}
	if (dayjs.isDayjs(date)) {
		return dayJsToStringFormat(date, format);
	}
	return getMoment(date).format(format);
}
const datetimeToString = date => datetimeToStringFormat(date, DATETIME_FORMAT);
// eslint-disable-next-line no-unused-vars
const datetimeToStringLog = label => date => {
	console.log(label, date);
	return datetimeToStringFormat(date, DATETIME_FORMAT);
}

const addDays = (date, days) => new Date(date.getTime() + days * DAY);

const getNowDayJs = () => dayjs().utc();
const getTodayDayJs = () => getNowDayJs().startOf('day');
// RangePicker date-only value is local midnight (UTC+4 → 20:00Z). Keep the calendar
// date the user picked and interpret it as UTC midnight.
const pickerDayToUtcDateStr = dayObj => dayObj.format(DATE_FORMAT);
const pickerDayToUtcDayStart = dayObj => dateStrToDayJs(pickerDayToUtcDateStr(dayObj));

const calcDatesRangeSafe = datesRange => {
	if (datesRange == null || datesRange.length !== 2) {
		return [null, null];
	}
	const rangeStart = pickerDayToUtcDayStart(datesRange[0]);
	const rangeEndExclusive = pickerDayToUtcDayStart(datesRange[1]).add(1, 'day');
	const nowMs = Date.now();
	let startMs = rangeStart.valueOf();
	let endMs = Math.min(rangeEndExclusive.valueOf(), nowMs);
	if (startMs >= endMs) {
		startMs = getTodayDayJs().valueOf();
		endMs = nowMs;
	}
	return [startMs, endMs];
};
// TODO почему используется getDayJsDiffMinutes в moduleStatuses? Там ведь дата-время
const getDayJsDiffMinutes = (start, end) => dateStrToDayJs(end).diff(dateStrToDayJs(start), 'minute');
const getDayJsDuration = (start, end) => dayjs.duration(end.diff(start, 'second'), 'seconds');

const isUtcMidnight = jsNativeDate => {
	const utcDate = dayjs.utc(jsNativeDate);
	return utcDate.hour() === 0 && utcDate.minute() === 0 && utcDate.second() === 0 && utcDate.millisecond() === 0;
};
const warningIfNotUtcMidnight = (jsNativeDate, varName, label) => {
	if (!jsNativeDate || !isUtcMidnight(jsNativeDate)) {
		console.warn('Date is not UTC midnight ' + varName + ' @ ' + label, jsNativeDate);
	}
};
// функция используется когда одобрено преобразование в лоб через dayjs
// проверено, что дата в utc, или это datetime
const jsNativeDateToDayJs = dayjs;

const roundMoment = (moment, unit, step) => {
	const remainder = moment[unit]() % step;
	return moment.startOf(unit).subtract(remainder, unit);
}

const roundNativeDate = (nativeDate, unit, step) => {
	return roundMoment(getMoment(nativeDate), unit, step).toDate();
}

const roundDayJs = (dayJs, unit, step) => {
	const remainder = dayJs[unit]() % step;
	return dayJs.startOf(unit).subtract(remainder, unit);
}

const useNow = () => {
	const now = ref(null);
	const timer = ref(null);
	const updateNow = () => {
		now.value = getNowDayJs();
	};
	onMounted(() => {
		timer.value = setInterval(updateNow, 60000);
	});
	onBeforeUnmount(() => clearInterval(timer.value));
	updateNow();
	return now;
};

export {
	getMomentUtc,
	dayJsToString,
	dayJsDatetimeToString,
	dateStrToDayJs,
	utcDatetimeStrToDayJs,
	datetimeToStringFormat,
	datetimeToString,
	addDays,
	getTodayDayJs,
	getNowDayJs,
	pickerDayToUtcDateStr,
	pickerDayToUtcDayStart,
	calcDatesRangeSafe,
	getDayJsDiffMinutes,
	getDayJsDuration,
	roundMoment,
	roundNativeDate,
	roundDayJs,
	useNow,
	warningIfNotUtcMidnight,
	jsNativeDateToDayJs,
	DATE_FORMAT,
	DATETIME_FORMAT,
	dateToUnix,
	isDayjs,
}
